import TongHopKetQua from './TongHopKetQua.jsx';

export {
  TongHopKetQua
}


// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/index.js